import '@/assets/js/rem'

import Vue from 'vue'
import App from './App.vue'
import router from './router'

//css
import '@/assets/css/commen.less';


//按需引入vant组件
import '@/assets/js/customVant'
import { List } from 'vant';
import { PullRefresh } from 'vant';
import { Loading } from 'vant';
import { Field } from 'vant';
import { Button } from 'vant';
import { RadioGroup, Radio } from 'vant';
import { NumberKeyboard } from 'vant';
import { Col, Row } from 'vant';
import { Divider } from 'vant';

Vue.use(Divider);
Vue.use(Col);
Vue.use(Row);
Vue.use(Button);
Vue.use(Field);
Vue.use(Loading);
Vue.use(PullRefresh);
Vue.use(List);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(NumberKeyboard);
//axios
import {postRequest} from "@/utils/api";
import {putRequest} from "@/utils/api";
import {getRequest} from "@/utils/api";

// 插件形式使用请求
Vue.prototype.postRequest = postRequest
Vue.prototype.putRequest = putRequest
Vue.prototype.getRequest = getRequest

Vue.config.productionTip = false

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
